import { AxiosHttpServiceBuilder } from '@wallbox/http'
import { wapiInternationalRepositoryBuilder } from './WapiInternationalRepository'

export const wapiInternationalRepository = () => {
  return wapiInternationalRepositoryBuilder({
    httpService: new AxiosHttpServiceBuilder()
  })
}
